/* eslint-disable react/display-name */
import React, { useState } from "react";
import { Field } from "@atlaskit/form";
import Modal, { ModalTransition, ModalFooter } from "@atlaskit/modal-dialog";
import ButtonGroup from "@atlaskit/button/button-group";
import Button from "@atlaskit/button/custom-theme-button";
import useAsync from "../../hooks/use-async";
import apiClient from "../../api/api-client";
import SectionMessage from "@atlaskit/section-message";
import styled from "styled-components";
import { toast } from "react-toastify";
import TextArea from "@atlaskit/textarea";
import { useTranslation } from "react-i18next";
import TextField from "@atlaskit/textfield";

export default function InviteToOrganization({ onClose, onSuccess, organizationId }) {
    const { run, isPending, error, isError: isCreatingError } = useAsync();
    const [email, setEmail] = useState("");
    const { t } = useTranslation();

    const footer = (props) => (
        <ModalFooter showKeyline={props.showKeyline}>
            <ButtonGroup>
                <Button appearance="primary" type="button" isLoading={isPending} onClick={handleSubmit}>
                    {t("organization_invite_submit")}
                </Button>
                <Button type="button" isDisabled={isPending} onClick={onClose}>
                    {t("organization_invite_cancel")}
                </Button>
            </ButtonGroup >
        </ModalFooter>
    );

    const handleSubmit = () => {
        run(apiClient(`adminableOrganizations/${organizationId}/invite`, { data: { email }, method: "POST" }))
            .then(res => {
                // if (res.status == 409) {
                //     toast.error(t("organization_invite_error"));
                //     return;
                // }

                toast.success(t("organization_invite_success"));
                onSuccess();
            })
            .catch(() => {
                toast.error(t("organization_invite_error"));
            });
    };

    return <ModalTransition>
        <Modal
            onClose={onClose}
            heading={t("organization_invite_heading")}
            scrollBehavior="inside-wide"
            components={{
                Footer: footer,
            }}
        >
            {isCreatingError && <SectionMessageWrapper>
                <SectionMessage title={t("organization_invite_error")} appearance="error">
                    <p>{error?.message}</p>
                    {error?.errors && <ul>
                        {Object.keys(error.errors).map(key => (
                            <li key={key}>{error.errors[key]}</li>
                        ))}
                    </ul>}
                </SectionMessage>
            </SectionMessageWrapper>}

            <Field name="data" label={t("organization_invite_email")} isRequired autoFocus isDisabled={isPending}>
                {({ fieldProps }) => <TextField
                    {...fieldProps}
                    value={email}
                    onChange={e => setEmail(e?.target?.value)}
                />}
            </Field>
        </Modal>
    </ModalTransition>;
}

const SectionMessageWrapper = styled.div`
    margin-top: 0px;
    font-size: 13px;
`;

